import styled, { css } from 'styled-components';
import { Link as LinkComponent } from 'react-router-dom';
import { media, remCalc, layout } from 'src/components/base';
import { ProductCoreProperties } from 'src/components/core-properties';
import { ActionButtonsMobile } from '../header-mobile/action-buttons';
import { ActionButtonsDesktop } from './action-buttons';
import { H2Text } from '@prisjakt/ui/text/variants';

export const StyledDesktopHeader = styled.header`
  display: none;

  ${media.mediumUp`
    flex-flow: row wrap;
    padding: ${layout.measurements.spacing050} ${
    layout.measurements.spacing050
  } ${layout.measurements.spacing150} ${layout.measurements.spacing050};
    position: relative;
    border-bottom: 1px solid ${p => p.theme.lines.primary};

    display: grid;
    grid-template-columns: 200px 1fr 310px;
    gap: ${layout.measurements.spacing100};
    grid-template-areas: "Media Content ProductSummary"
  `}

  ${media.mediumDown`
    padding-left: ${layout.measurements.spacing100};
    padding-right: ${layout.measurements.spacing100};
    padding-bottom: 1rem;
    grid-template-columns: 200px 1fr auto;
    grid-template-areas:
      "TabletTitle TabletTitle TabletTitle"
      "Media Content ProductSummary"
  `}
`;

export const StyledProductSummary = styled.div`
  /* width is the same as price history graph on desktop.
  It's set to keep up space while rendering. */
  width: 310px;
  flex: 0 0 auto;
  grid-area: ProductSummary;

  ${media.mediumDown`
    width: auto;
  `}
`;

type TitleProps = {
  $inner?: boolean;
  $outer?: boolean;
};
export const StyledTitle = styled(H2Text).attrs({
  container: 'h1',
})<TitleProps>`
  margin-bottom: ${layout.measurements.spacing050};

  ${props =>
    props.$inner &&
    css`
      margin-right: 20px;
    `}

  ${props =>
    props.$outer &&
    css`
      flex: 1 0 auto;
      margin-bottom: 0;
      margin-right: 0px;
    `}
`;

export const StyledMore = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledContent = styled.div`
  flex: 1 1;
  justify-content: space-between;
  padding-right: ${layout.measurements.spacing050};
  padding-left: ${layout.measurements.spacing050};
  min-width: 0;
  grid-area: Content;
`;

export const StyledMedia = styled.div`
  grid-area: Media;
  position: relative;
  margin-right: ${layout.measurements.spacing100};
`;

export const StyledStoreLogo = styled(LinkComponent)`
  position: absolute;
  text-align: center;
  bottom: calc(100% + 2px);
  max-height: 25px;
  right: 10px;

  img {
    max-width: 88px;
  }
`;

export const StyledWriteReview = styled.div`
  cursor: pointer;
  color: ${p => p.theme.text.linkExternal};
  font-weight: 600;
  display: flex;
  flex-wrap: nowrap;
  gap: ${remCalc(4)};
  align-items: center;

  &:hover,
  &:focus {
    color: ${p => p.theme.text.linkExternalHover};
    text-decoration: underline;
  }
`;

export const StyledRatingWrapper = styled.div`
  margin-bottom: ${remCalc(10)};
  color: ${p => p.theme.text.callToAction};

  span {
    color: inherit;
  }
  &:hover span {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const StyledDisplayProperties = styled(ProductCoreProperties)`
  margin: 0 0 ${layout.measurements.spacing050};
`;

export const StyledReviewBadges = styled.div`
  margin: 0 0 ${layout.measurements.spacing050};
`;

export const StyledBadges = styled.div`
  display: flex;
  gap: ${layout.measurements.spacing050};
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const StyledTabletTitle = styled.div`
  display: none;
  grid-area: TabletTitle;

  ${media.mediumDown`
    display: block;
  `}
`;

export const StyledDesktopTitle = styled.div`
  display: none;

  ${media.largeUp`
    display: block;
  `}
`;

export const StyledTabletActionButtons = styled(ActionButtonsMobile)`
  display: none;

  ${media.mediumDown`
    display: block;
  `}
`;

export const StyledDesktopActionButtons = styled(ActionButtonsDesktop)`
  display: none;

  ${media.largeUp`
    display: flex;
  `}
`;
